import _ from 'lodash';
import { getEventSession } from './event-session-service';
import { PeopleIncrementalPropertiesEnum, PeoplePropertiesEnum, PeopleSetPropertiesEnum, updatePeopleProperty, } from './mixpanel-people-properties';
import { SessionPropsEnum, } from './mixpanel-session-properties';
let mixpanelDNT = false;
export let mixpanel;
let mixpanelSessionProperties;
let isMixpanelEnabled;
export async function initService(token, mixpanelLib, mixpanelSessionProps, debugMode, mixpanelApiHost, enableCrossSubDomainCookie, useLocalStorage) {
    mixpanel = mixpanelLib;
    const persistence = useLocalStorage ? 'localStorage' : 'cookie';
    if (mixpanelApiHost) {
        mixpanel.init(token, {
            api_host: mixpanelApiHost,
            cross_subdomain_cookie: enableCrossSubDomainCookie,
            persistence,
        });
    }
    else {
        mixpanel.init(token, {
            cross_subdomain_cookie: enableCrossSubDomainCookie,
            persistence,
        });
    }
    if (debugMode) {
        mixpanel.set_config({ debug: true });
    }
    mixpanel.set_config({ ignore_dnt: true });
    mixpanelSessionProperties = mixpanelSessionProps;
    isMixpanelEnabled = true;
    return true;
}
export function uploadEvent(eventId, eventProps) {
    mixpanel.track(eventId, eventProps);
}
export function uploadEventBatch(eventBatch) {
    eventBatch.forEach((evt) => {
        uploadEvent(evt.id, evt.props);
    });
}
export function isBlocked(url = 'https://api.mixpanel.com/') {
    return fetch(url, { mode: 'no-cors' })
        .then(() => false)
        .catch(() => true);
}
export function isOptedOut() {
    return mixpanel.has_opted_out_tracking();
}
export function setOptInTracking() {
    mixpanel.clear_opt_in_out_tracking();
    mixpanel.opt_in_tracking();
}
export function updateMixPanelProperty(key, value) {
    if (!isMixpanelEnabled) {
        return;
    }
    const isInPeopleProperties = _.includes(_.values(PeoplePropertiesEnum), key) ||
        _.includes(_.values(PeopleIncrementalPropertiesEnum), key) ||
        _.includes(_.values(PeopleSetPropertiesEnum), key);
    const isInSessionProperties = _.includes(_.values(SessionPropsEnum), key);
    if (!isInPeopleProperties && !isInSessionProperties) {
        throw new Error('Property does not exists in current set of properties');
    }
    if (isInPeopleProperties) {
        updatePeopleProperty(key, value);
    }
    if (isInSessionProperties) {
        mixpanelSessionProperties.updateSessionProperty(key, value);
    }
}
export function getSessionProperties() {
    return getEventSession();
}
export function isMixpanelDNT() {
    return mixpanelDNT;
}
export function setMixpanelDNT(value) {
    mixpanelDNT = value;
}
//# sourceMappingURL=mixpanel-service.js.map